// extracted by mini-css-extract-plugin
module.exports = {"container":"LegendeAbsence_container__jLkCW","actions":"LegendeAbsence_actions__wd8PQ","divider":"LegendeAbsence_divider__2XW6B"};